import { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import Modal from '../../containers/common/Modal';
import { ErrorText } from './common';
import { postCurrentBP } from '../../services';
import { FlyInTransition } from '../transitions/transitions';

import closeIcon from '../../images/health-content/close-modal.svg';
import ClockIcon from '../../images/health-content/clock-icon.svg';
import BloodPressureIcon from '../../images/health-content/blood-pressure-icon.svg';

const BPInputBox = styled.input`
  width: 70%;
  border-bottom: 1px solid black;
  font-size: 48px;
  font-weight: 700;
  color: #01040d;
  text-align: center;
  ::placeholder {
    text-align: center;
    font-size: 48px;
    font-weight: 500;
  }
`;

const BloodPressureModal = ({ hideModal, measuredOn }) => {
  const [showModal, setShowModal] = useState(true);
  const [systolicValue, setSystolicValue] = useState('');
  const [diastolicValue, setDiastolicValue] = useState('');
  const [showErrorText, setShowErrorText] = useState(false);
  const { authToken } = useSelector((state) => state.user);
  const timer = useRef(null);

  const validateInput = () => {
    if (
      Number(systolicValue) < 70 ||
      Number(systolicValue) > 300 ||
      Number(diastolicValue) < 40 ||
      Number(diastolicValue) > 200 ||
      Number(systolicValue) < Number(diastolicValue)
    )
      return false;
    else return true;
  };

  useEffect(() => {
    if (!showModal)
      timer.current = setTimeout(() => {
        hideModal();
      }, 300);
    return () => {
      clearTimeout(timer);
      timer.current = null;
    };
  }, [showModal]);

  return (
    <Modal>
      <div
        className="modalContainer"
        onClick={(e) => {
          e.stopPropagation();
          setShowModal(false);
        }}
      >
        <FlyInTransition in={showModal} mountOnEnter unmountOnExit appear>
          <div className="modalBody" onClick={(e) => e.stopPropagation()}>
            <div
              style={{
                paddingLeft: '0',
                paddingRight: '0',
                overflowY: 'auto',
                minHeight: '150px',
              }}
            >
              <div className="flex justify-between items-center border-b border-txtlight-shades4 p-16px ">
                <div className="flex items-center">
                  <img src={BloodPressureIcon} alt=""></img>
                  <p className="ml-12px text-body-m font-semibold">
                    Blood Pressure
                  </p>
                </div>
                <img
                  src={closeIcon}
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowModal(false);
                  }}
                  className="clickable"
                  alt=""
                />
              </div>
              <div className="flex py-40px justify-between items-center flex-col h-full">
                <p className="text-title-xl font-bold">Enter the value</p>
                <div className="flex justify-evenly items-center">
                  <div className="flex flex-col justify-center items-center">
                    <BPInputBox
                      type="number"
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                      placeholder="00"
                      id="systolic"
                      onChange={(e) => setSystolicValue(e.target.value)}
                    />
                    <label for="systolic" className="mt-4px">
                      Systolic
                    </label>
                  </div>
                  <span className="mx-18px my-auto">/</span>
                  <div className="flex flex-col justify-center items-center">
                    <BPInputBox
                      type="number"
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                      placeholder="00"
                      id="diastolic"
                      onChange={(e) => setDiastolicValue(e.target.value)}
                    />
                    <label for="diastolic" className="mt-4px">
                      Diastolic
                    </label>
                  </div>
                </div>
                {showErrorText && <ErrorText />}
                <div className="flex flex-col justify-center items-center">
                  <div className="flex flex-col mt-52px">
                    <div className="flex">
                      <img src={ClockIcon} alt=""></img>
                      <p className="text-body-s text-sub ml-8px">
                        Last Measured On
                      </p>
                    </div>
                    <p className="text-body-l font-medium text-txtlight self-center">
                      {measuredOn ? measuredOn : 'N/A'}
                    </p>
                  </div>
                  <p className="text-body-s"></p>
                </div>
                {systolicValue.length > 0 && diastolicValue.length > 0 && (
                  <div className="pb-20px px-20px mt-28px w-full">
                    <button
                      onClick={async (e) => {
                        try {
                          if (validateInput()) {
                            await postCurrentBP(authToken, {
                              systolic: systolicValue,
                              diastolic: diastolicValue,
                              measuredOn: new Date().toISOString().slice(0, 10),
                            });
                            setShowErrorText(false);
                            hideModal();
                          } else {
                            e.stopPropagation();
                            setShowErrorText(true);
                          }
                        } catch (error) {
                          console.error('Error posting BP:', error);
                        }
                      }}
                      className="flex justify-center w-full bg-primary text-textbox mb-20px rounded-12 text-body-s font-semibold py-14px"
                    >
                      Save
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </FlyInTransition>
      </div>
    </Modal>
  );
};

export default BloodPressureModal;
